export const maxHigh =630;
export const minLow =20;
